export const messages = {
  en: {
    appSubtitle: "Professional repair shop platform",
    signIn: "Sign in", signInHint: "Use your organization account to continue.",
    email: "Email", alternatePhone: "Alternate phone", password: "Password", invalidLogin: "Unable to sign in. Check your credentials.",
    foundation: "Dashboard", foundationHint: "Production infrastructure status and access controls.",
    users: "Users", userManagement: "User management", usersAndPermissions: "Users & permissions",
    roleManagement: "Role management", activity: "Activity logs", signOut: "Sign out",
    currentAccount: "Current account", changePassword: "Change password", personalSettings: "Personal settings",
    displayName: "Display name", currentPassword: "Current password", newPassword: "New password",
    confirmNewPassword: "Confirm new password", passwordsDoNotMatch: "The passwords do not match.",
    passwordChanged: "Password changed. Sign in again with the new password.",
    passwordChangeHint: "Changing your password signs out every existing refresh session.",
    roleManagementHint: "Create organization roles, assign permissions, and disable roles without deleting history.",
    newRole: "New role", editRole: "Edit role", roleName: "Role name", roleDescription: "Description",
    permissions: "Permissions", systemRole: "System", customRole: "Custom", enabled: "Enabled", disabled: "Disabled",
    disableRole: "Disable role", enableRole: "Enable role", disableRoleConfirm: "Assigned users immediately lose permissions from this role.",
    roleUsers: "Assigned users", adminRoleProtected: "The system administrator role cannot be disabled, renamed, or lose permissions.",
    roleSaved: "Role saved.", accessDenied: "You do not have permission to access this page.",
    userManagementHint: "Add staff, assign their operating role, and manage account access.",
    addPerson: "Add person", editProfile: "Edit profile", changeRole: "Change role", resetPassword: "Reset password",
    temporaryPassword: "Temporary password", temporaryPasswordHint: "The person must replace this temporary password at first sign-in.",
    passwordChangeRequired: "Password change required", firstLoginPasswordHint: "Replace your temporary password before accessing AutoFlow Pro.",
    staffRoleAdmin: "Administrator", staffRoleManager: "Manager", staffRoleFrontDesk: "Front Desk", staffRoleTechnician: "Technician",
    disablePerson: "Disable person", enablePerson: "Enable person", disablePersonConfirm: "This person will immediately lose account access.",
    enablePersonConfirm: "This person will be able to sign in again.", selfAdminRoleProtected: "You cannot remove your own administrator role.",
    resetPasswordHint: "Existing refresh sessions will be revoked and the person must change this temporary password at next sign-in.",
    personAdded: "Person added.", personUpdated: "Profile updated.", roleAssignmentUpdated: "Role assignment updated.",
    temporaryPasswordReset: "Temporary password reset.", personStatusUpdated: "Account status updated.",
    language: "Language", theme: "Theme", light: "Light", dark: "Dark",
    status: "Status", service: "Service", ready: "Ready", phase: "Current phase",
    phaseOne: "Phase 1 · Infrastructure", scope: "Approved scope",
    scopeText: "Authentication, RBAC, database, Docker, i18n, theme and structured logging.",
    noBusiness: "Business modules are intentionally not enabled in Phase 1.",
    phaseTwo: "Sprint 2 · Business Foundation",
    sprintTwoScope: "Customer, Vehicle, and Repair Order foundations with validated workflow and audit history.",
    noInventory: "Inventory, Purchase, Payment, and Reports are intentionally not implemented.",
    phaseThree: "Sprint 3 · Repair Workspace",
    sprintThreeScope: "One persistent working environment organized around completing each repair.",
    workspaceOnly: "Workflow section business behavior remains reserved for later architecture approval.",
    phaseFour: "Sprint 4 · Complete Repair Workflow",
    sprintFourScope: "Create and complete a real Repair Order from inspection through invoice and payment.",
    workflowLive: "Inspection, estimate approval, labor, parts issue, invoice, and payment are operational.",
    name: "Name", roles: "Roles", active: "Active", created: "Created",
    action: "Action", entity: "Entity", actor: "Actor", time: "Time",
    customers: "Customers", customer: "Customer", customerListHint: "Search people and businesses, vehicles, and service history.",
    newCustomer: "New customer", editCustomer: "Edit customer", customerProfile: "Customer profile",
    vehicles: "Vehicles", vehicle: "Vehicle", vehicleListHint: "Customer-owned vehicles indexed by VIN.",
    newVehicle: "New vehicle", editVehicle: "Edit vehicle", vehicleProfile: "Vehicle profile",
    detailedConfiguration: "Detailed configuration", vehicleConfiguration: "Vehicle configuration",
    backToVehicle: "Back to vehicle", nhtsaVehicleConfiguration: "NHTSA vehicle specifications",
    noDecodedSpecifications: "No decoded specifications are available.",
    modelYear: "Model year", trim: "Trim", series: "Series", bodyClass: "Body class",
    vehicleType: "Vehicle type", manufacturer: "Manufacturer", driveType: "Drive type",
    doors: "Doors", gvwr: "Gross vehicle weight rating", brakeSystem: "Brake system",
    tractionControl: "Traction control", manufacturingPlant: "Manufacturing plant",
    repairOrders: "Repair orders", repairWorkspace: "Repair Workspace",
    workshopOperations: "Workshop operations", technicianQueue: "Technician queue",
    technicianQueueHint: "Live Services ordered by the next action required to move each vehicle forward.",
    myQueue: "My queue", shopQueue: "Shop queue", activeServices: "Active Services",
    waitingAttention: "Waiting / attention", qcQueue: "QC queue", liveUpdated: "Live updated",
    noServicesInQueue: "No Services require action in this queue.", openRepairEvent: "Open Repair Event",
    actualWorkTime: "Actual work time", pause: "Pause", resume: "Resume", qc: "QC",
    qcPass: "Pass QC", qcFail: "Fail / rework",
    workSessionRUNNING: "Running", workSessionPAUSED: "Paused", workSessionCOMPLETED: "Completed",
    queueActionWAIT_CUSTOMER_APPROVAL: "Waiting customer",
    queueActionISSUE_PARTS: "Issue parts", queueActionSTART_SERVICE: "Start Service",
    queueActionCONTINUE_SERVICE: "Work in progress", queueActionRESUME_SERVICE: "Resume Service",
    queueActionSEND_TO_QC: "Send to QC", queueActionPERFORM_QC: "Perform QC",
    queueActionQC_COMPLETE: "QC complete",
    priorityLOW: "Low", priorityNORMAL: "Normal", priorityHIGH: "High", priorityURGENT: "Urgent",
    repairOrderListHint: "Open and historical repair orders across the shop.",
    newRepairOrder: "New repair order", search: "Search", save: "Save", cancel: "Cancel",
    edit: "Edit", delete: "Delete", phone: "Phone", company: "Company", individual: "Individual",
    salutation: "Title", mr: "Mr.", ms: "Ms.",
    tags: "Tags", notes: "Notes", attachments: "Attachments", history: "History",
    owner: "Owner", vin: "VIN", plate: "License plate", year: "Year", make: "Make", model: "Model",
    mileage: "Mileage", color: "Color", engine: "Engine", transmission: "Transmission", fuelType: "Fuel type",
    lastVisitAt: "Last shop visit",
    overview: "Overview", inspection: "Pre-inspection", estimate: "Estimate", preInspectionEstimate: "Pre-Inspection & Estimate", labor: "Labor", parts: "Parts",
    photos: "Photos", timeline: "Timeline", invoice: "Invoice", payment: "Payment", repairHistory: "Repair history", activityLog: "Activity Log",
    openWorkspace: "Open workspace",
    customerConcern: "Customer concern", internalNotes: "Internal notes", promisedAt: "Promised time",
    changeStatus: "Change status", noData: "No records found",
    repairStatus: "Repair status", priority: "Priority", normalPriority: "Normal",
    advisor: "Advisor", technician: "Technician", unassigned: "Unassigned",
    workspaceNavigation: "Repair workflow navigation", workspaceActions: "Repair workflow actions",
    repairWorkflow: "Repair workflow", vehicleSummary: "Vehicle summary", customerSummary: "Customer summary",
    currentStatus: "Current status", warranty: "Warranty", openBalance: "Open balance",
    notConfigured: "Not configured", approve: "Confirm with customer", issueParts: "Issue parts",
    print: "Print", closeRepairOrder: "Close repair order", repairInformation: "Repair information",
    location: "Location", openedAt: "Opened", recentActivity: "Recent activity",
    lowPriority: "Low", highPriority: "High", urgentPriority: "Urgent",
    yes: "Yes", no: "No", workflowProgress: "Repair progress", checkedIn: "Checked in",
    closed: "Closed", nextWorkflowAction: "Next workflow action", repairCompleted: "Repair order completed",
    addInspectionFinding: "Add pre-inspection finding", inspectionItem: "Pre-inspection item",
    pass: "Normal", attention: "Abnormal", fail: "Abnormal", normal: "Normal", abnormal: "Abnormal", add: "Add",
    repairRecommendation: "Repair recommendation",
    completeInspection: "Complete pre-inspection", addEstimateItem: "Add estimate item",
    fee: "Fee", sequence: "No.", type: "Type", description: "Description", unitPrice: "Unit price", amount: "Amount",
    laborCost: "Labor", materialCost: "Materials", grandTotal: "Grand total",
    generateEstimatePdf: "Print Estimate PDF", printEstimatePdf: "Print Estimate PDF",
    total: "Total", subtotal: "Subtotal", tax: "Tax", discount: "Discount", quantity: "Quantity", hours: "Hours",
    selectPart: "Select part", submitForApproval: "Submit for approval",
    shopWork: "Shop Work", repairProjects: "Repair projects", vehicleRepairProjects: "Vehicle repair projects", repairItem: "Repair item",
    requiredMaterials: "Required materials", materials: "Materials", materialName: "Material",
    addItem: "Add item", selectTechnician: "Select technician",
    customerSuppliedParts: "Customer-supplied parts", noCustomerSuppliedParts: "No customer-supplied parts recorded.",
    completeAndSendToInspector: "Complete and send to inspector",
    settlement: "Settlement", settlementBreakdown: "Settlement breakdown", otherCharges: "Other charges",
    financialAdjustmentsBeforeCollection: "Other charges and discount may be finalized until the first collection is recorded.",
    financialAdjustmentsLocked: "Other charges and discount are locked after customer approval once collection begins.",
    completeAndSettle: "Complete and settle",
    addLabor: "Add labor", addMaterial: "Add material", addCustomerSuppliedPart: "Add customer-supplied part",
    inventoryMaterial: "Inventory material", freeMaterial: "Custom material",
    sku: "SKU", materialSupplier: "Supplier",
    workshopNotesAndDisclaimer: "Notes and disclaimer", workshopNotes: "Notes",
    workshopNotesPlaceholder: "Enter workshop notes",
    disclaimer: "Disclaimer",
    customerSuppliedPartDisclaimer: "Customer-supplied parts may not be covered by the shop's parts warranty. Labor warranty and legal rights remain subject to applicable law and the shop's written policy.",
    collectPayment: "Collect payment", paymentAvailableAfterInspection: "Payment becomes available after the inspector passes the vehicle and the invoice is issued.",
    passInspectionIssueInvoice: "Pass inspection and issue invoice",
    paymentMethodCASH: "Cash", paymentMethodTRANSFER: "Transfer", paymentMethodCHECK: "Check",
    paymentMethodPAYPAL: "PayPal", paymentMethodZELLE: "Zelle",
    printEstimate: "Print estimate", printWorkshopOrder: "Print workshop repair order",
    printSettlement: "Print settlement statement", workshopRepairOrder: "Workshop Repair Order",
    settlementStatement: "Settlement Statement",
    uploadAttachment: "Upload attachment", confirmationAttachments: "Confirmation attachments",
    customerApprovalName: "Customer name", approveEstimate: "Confirm with customer",
    customerConfirmationName: "Customer name", confirmWithCustomer: "Confirm with customer",
    confirmationText: "Text message", confirmationImage: "Image",
    confirmationRecording: "Phone recording", confirmationSignedEstimate: "Signed estimate",
    confirmationEvidence: "Evidence note or file reference",
    customerConfirmedBy: "Confirmed by customer",
    supplementRequired: "Supplement Required / Customer Re-Approval",
    supplementRequiredHint: "Additional labor or materials were added. Work, quality check, invoicing, and settlement are blocked until the customer approves the supplement.",
    supplementChangedScope: "Changes requiring approval", supplementEstimateChanges: "Labor / parts price or quantity changed",
    supplementTotal: "Revised total",
    approveSupplement: "Approve supplement",
    serviceIntelligence: "Service Intelligence",
    workflowFirst: "Workflow first",
    serviceIntelligenceHint: "Add a matched service first. Labor guide, recommended parts, and inspection rules are applied from the knowledge base.",
    searchMatchedService: "Search services matched to this vehicle",
    addService: "Add Service",
    serviceChangeStatusHint: "Services can be changed during estimate preparation or active repair.",
    noServices: "No structured services on this repair order.",
    repairOperatingSystem: "Repair Operating System", repairEventExperience: "Repair Event Workspace",
    roleWorkflowFocus: "Role workflow focus", advisorWorkflowFocus: "Communication · estimate · approval · payment",
    technicianWorkflowFocus: "Inspection · Services · evidence · labor · QC",
    partsWorkflowFocus: "Required parts · readiness · issue", ownerWorkflowFocus: "Flow · bottlenecks · delivery",
    whatHappensNextForVehicle: "Every action moves this vehicle closer to delivery.",
    visitReason: "Visit reason", visitReasonHint: "Customer wording and advisor clarification remain distinct.",
    customerWords: "Customer words", awaitingAdvisorClarification: "Awaiting advisor clarification",
    whatWeFound: "What we found", whatWeFoundHint: "Inspection findings and evidence explain what the vehicle needs.",
    whatWeRecommend: "What we recommend", serviceCardsAreWorkUnits: "Services connect findings, approval, parts, labor, work, QC, and price.",
    customerDecision: "Customer decision", customerDecisionHint: "The approved scope and every supplement remain visible.",
    shopExecution: "Shop execution", shopExecutionHint: "Technicians complete authorized Services without leaving this Repair Event.",
    commercialClose: "Commercial close", commercialCloseHint: "QC, invoice, payment, and release complete the visit.",
    timelineV2: "Timeline V2", timelineImmutableHint: "An immutable operational story generated by every important action.",
    timelineFilterALL: "All", timelineFilterCUSTOMER: "Customer",
    timelineFilterWORK: "Work", timelineFilterPARTS: "Parts",
    timelineFilterQC: "QC", timelineFilterCOMMERCIAL: "Invoice / payment",
    repairHistoryHint: "The durable vehicle record created from completed Repair Events.",
    businessOperations: "Business operations",
    invoiceIssued: "Invoice issued", paymentComplete: "Payment complete",
    vehicleDelivered: "Vehicle delivered", historyCompleted: "History completed",
    customerCommunication: "Customer communication",
    communicationChannelSMS: "SMS", communicationChannelEMAIL: "Email",
    communicationChannelPHONE: "Phone", communicationChannelIN_PERSON: "In person",
    communicationPurposeESTIMATE: "Estimate", communicationPurposeAPPROVAL: "Approval",
    communicationPurposeREADY_FOR_PICKUP: "Ready for pickup",
    communicationPurposeINVOICE: "Invoice", communicationPurposePAYMENT_RECEIPT: "Payment receipt",
    communicationPurposeDELIVERY: "Delivery", communicationPurposeFOLLOW_UP: "Follow-up",
    communicationPurposeWARRANTY: "Warranty",
    recipient: "Recipient", communicationMessage: "Communication note",
    recordCommunication: "Record communication", noCustomerCommunications: "No customer communications recorded.",
    vehicleDelivery: "Vehicle delivery", deliverVehicle: "Deliver vehicle",
    deliverVehicleAndCompleteHistory: "Deliver vehicle & complete history",
    deliveryRecipient: "Released to", mileageOut: "Mileage out", deliveryNotes: "Delivery notes",
    deliveryRequiresPayment: "The invoice must be fully paid before the vehicle can be released.",
    releasedAt: "Released at", releasedBy: "Released by",
    warrantyCoverage: "Warranty coverage", laborWarrantyEnds: "Labor coverage ends",
    partsWarrantyEnds: "Parts coverage ends", noWarrantyCoverage: "No Service warranty applies.",
    permanentRepairHistory: "Permanent service history",
    historyCreatedAtDelivery: "Permanent service history is created when the vehicle is delivered.",
    system: "System",
    forensicAuditHint: "Forensic system activity retained separately from the operational story.",
    serviceOriginFINDING: "Finding", serviceOriginCUSTOMER_REQUEST: "Customer request",
    serviceOriginMAINTENANCE: "Maintenance", serviceOriginREPAIR_RULE: "Repair rule", serviceOriginMANUAL: "Manual",
    serviceUrgencyIMMEDIATE: "Immediate", serviceUrgencySOON: "Soon", serviceUrgencyROUTINE: "Routine",
    serviceStatusPROPOSED: "Proposed", serviceStatusAPPROVED: "Approved", serviceStatusDECLINED: "Declined",
    serviceStatusIN_PROGRESS: "In progress", serviceStatusCOMPLETED: "Completed",
    serviceQcNOT_REQUIRED: "Not required", serviceQcPENDING: "Pending", serviceQcPASSED: "Passed", serviceQcFAILED: "Failed",
    whyThisService: "Why this Service", customerRequest: "Customer request", recommendation: "Recommendation",
    knowledgeRuleApplied: "Repair knowledge rule applied", startServiceWork: "Start Service",
    completeServiceWork: "Complete Service", addEvidence: "Add evidence",
    evidencePHOTO: "Photo", evidenceVIDEO: "Video", evidenceMEASUREMENT: "Measurement", evidenceOBD: "OBD",
    evidenceDOCUMENT: "Document", evidenceAUDIO: "Audio", evidenceSIGNATURE: "Signature",
    evidenceOEM_REFERENCE: "OEM reference", evidenceSummary: "What does this evidence show?",
    measurementOrCode: "Measurement or diagnostic code", unit: "Unit", chooseEvidenceFile: "Choose evidence file",
    customerVisible: "Customer visible", internalOnly: "Internal only", saveEvidence: "Save evidence",
    evidence: "Evidence", noServiceEvidence: "No evidence attached to this Service.",
    workStatus: "Work status", partsReadiness: "Parts readiness", months: "months",
    serviceTotal: "Service total", serviceTimeline: "Service timeline", noServiceTimeline: "No Service activity yet.",
    serviceApproved: "Approved",
    serviceProposed: "Proposed",
    oemLaborTime: "OEM labor time",
    shopLaborTime: "Shop labor time",
    finalLaborTime: "Final labor time",
    laborRate: "Labor rate",
    laborAmount: "Labor amount",
    laborOverride: "Labor override",
    overrideLabor: "Override labor",
    overrideReasonRequired: "Override reason (required)",
    addPartToService: "Add part to service",
    partNumber: "Part number",
    recommendedParts: "Service parts",
    noRecommendedParts: "No recommended parts.",
    inspectionRecommendations: "Inspection and recommendations",
    noRecommendations: "No linked rules.",
    source: "Source",
    issueStatus: "Issue status",
    notIssued: "Not issued",
    ruleRECOMMEND_SERVICE: "Recommended service",
    ruleRECOMMEND_PART: "Recommended part",
    ruleINSPECTION: "Inspection",
    ruleMESSAGE: "Instruction",
    manualLaborPartFallback: "Manual labor and material entry remains available below as a fallback.",
    taxableMaterials: "Taxable parts / materials",
    losAngelesSalesTax: "Los Angeles sales tax (9.75%)",
    approvedBy: "Confirmed by", startRepairWork: "Start repair work", authorizedLabor: "Authorized labor",
    start: "Start", complete: "Complete", awaitingApprovedEstimate: "Waiting for an approved estimate.",
    requiredParts: "Required parts", required: "Required", issued: "Issued", onHand: "On hand", issue: "Issue",
    repairPhotos: "Repair photos", upload: "Upload", invoiceCreatedAtReadyDelivery: "Invoice is issued after quality check.",
    invoiceRequiredBeforePayment: "Complete quality check and issue the invoice before payment.",
    recordPayment: "Record payment", reference: "Reference", paymentHistory: "Payment history", paid: "Paid",
    roNumberAutomatic: "The repair order number is generated automatically when saved.",
    checkInVehicle: "Check in vehicle", checkInDescription: "Confirm the vehicle has arrived and begin the repair workflow.",
    startWorkDescription: "The customer approved the estimate. Begin authorized work.",
    beginQualityCheck: "Submit to shop inspector", qualityDescription: "All authorized work is complete. Send the vehicle to final inspection.",
    passQcIssueInvoice: "Pass inspection and notify customer", readyDescription: "Record the inspector's acceptance, issue the invoice, and notify the customer for pickup.",
    closeDescription: "Payment is complete. Close the repair order.",
    qaTools: "Quality assurance", inputStandardsTest: "Input standards test",
    inputStandardsHint: "A controlled page for verifying keyboard input and display formatting.",
    qaOnly: "QA only", keyboardTestHint: "Use Tab to move between fields and Enter to submit the test form.",
    vinStandard: "VIN normalization", vinStandardHelp: "17 characters; uppercase; I, O, and Q are not allowed.",
    phoneStandard: "US phone formatting", phoneStandardHelp: "Enter digits continuously; punctuation is inserted automatically.",
    dateStandard: "Date and time format", dateAndTime: "Date and time",
    currencyStandard: "US dollar format", currencyAmount: "Amount",
    mileageStandard: "Mileage format", roNumberStandard: "Repair order number",
    actualValue: "Actual value", generatedFormat: "Generated format", generationOwner: "Generated by",
    testKeyboardSubmit: "Test Enter submission", resetTestValues: "Reset values",
    keyboardSubmitPassed: "Keyboard submission passed",
    frontDesk: "Front Desk", todaysRepairs: "Today's Repairs", inventory: "Inventory", inventoryManagement: "Inventory", inventoryOverview: "Inventory overview",
    purchase: "Purchase", reports: "Reports", administration: "Settings",
    today: "Today", vehiclesToday: "vehicles today", todaysVehicles: "Today's Vehicles",
    frontDeskHint: "Find the next repair action, check in a vehicle, and keep today's work moving.",
    frontDeskV2Hint: "Find the vehicle, capture why it arrived, and move directly to its next repair action.",
    universalCommandBar: "Universal Command Bar", commandBarPlaceholder: "VIN, plate, customer, RO, or command",
    commandBarHint: "Search or act without leaving the Repair Event", printInvoice: "Print invoice",
    target60Seconds: "Target under 60 sec", searchValueWillBeReused: "Your search will be carried into the arrival form.",
    startNewRepairEvent: "Start New Repair Event", newRepairEvent: "New Repair Event",
    activeVehicles: "Active vehicles", overdueAttention: "Overdue attention", promiseRisk: "Promise risk",
    nextActionBoardHint: "Each lane shows who owns the next action for the vehicle.",
    noVehiclesWaiting: "No vehicles waiting", activeRepairEvents: "Active repair events",
    continueActiveRepair: "Continue active repair", selectVehicleNext: "Select vehicle next",
    nextAction: "Next action", minutesWaiting: "min waiting", waiting: "waiting",
    attentionWaitingInspection: "Waiting inspection", attentionWaitingEstimate: "Waiting estimate",
    attentionWaitingApproval: "Waiting customer", attentionWaitingParts: "Waiting parts",
    attentionWorkshop: "Workshop", attentionWaitingQc: "Waiting QC", attentionPaymentPickup: "Payment / pickup",
    attentionDRAFT: "Draft", attentionWAITING_INSPECTION: "Waiting inspection",
    attentionWAITING_ESTIMATE: "Waiting estimate", attentionWAITING_CUSTOMER_APPROVAL: "Waiting customer approval",
    attentionWAITING_PARTS: "Waiting parts", attentionWAITING_TECHNICIAN: "Waiting technician",
    attentionWORK_IN_PROGRESS: "Work in progress", attentionWAITING_QC: "Waiting QC",
    attentionWAITING_PAYMENT: "Waiting payment", attentionREADY_PICKUP: "Ready pickup",
    attentionREADY_TO_CLOSE: "Ready for delivery",
    completeCheckIn: "Complete check-in", startInspection: "Start inspection", buildEstimate: "Build estimate",
    followUpApproval: "Follow up approval", resolveParts: "Resolve parts", dispatchService: "Assign technician",
    continueRepair: "Continue repair", performQc: "Perform quality check",
    closeRepairEvent: "Close repair event", viewRepairHistory: "View repair history",
    roleFRONT_DESK: "Front Desk", roleTECHNICIAN: "Technician", roleADVISOR: "Advisor",
    roleWAREHOUSE: "Warehouse", roleDISPATCHER: "Dispatcher", roleQC: "QC", roleNONE: "Unassigned",
    globalSearchPlaceholder: "Search VIN, plate, phone, customer, or RO number",
    boardCheckedIn: "Checked In", boardWaitingApproval: "Waiting Approval", boardApproved: "Approved",
    boardInProgress: "In Progress", boardWaitingParts: "Waiting Parts", boardReadyPickup: "Ready Pickup",
    boardUpdatesAutomatically: "Live workflow view · refreshes every 30 seconds",
    noPlate: "No plate", noSearchResults: "No matching customer, vehicle, or repair order.",
    noVehicles: "No vehicles", noPromiseTime: "No promised time", searching: "Searching…",
    scan: "Scan", scanHint: "Scan a VIN, RO QR code, or part barcode.",
    stopCamera: "Stop camera", useCamera: "Use camera", orUseScanner: "or use a USB/Bluetooth scanner",
    scanVin: "Scan VIN", scanPlate: "Scan license plate", chooseFromPhotos: "Choose from photos",
    fieldScanHint: "Use the camera or select an existing barcode/QR photo.",
    invalidVinScan: "A valid 17-character VIN was not found.",
    invalidPlateScan: "A valid license plate value was not found.",
    photoScanFailed: "No readable barcode or QR code was found in this photo.",
    scanInputPlaceholder: "Scan or enter code, then press Enter", go: "Go",
    repairOrderNotFound: "Repair order not found.", partScanWorkspaceOnly: "Part scanning is available inside a Repair Workspace.",
    scanNotRecognized: "The scanned code was not recognized.", cameraUnavailable: "Camera is unavailable or permission was denied.",
    scanPhotoUnreadable: "No readable VIN, repair-order QR code, or barcode was found in this photo.",
    chooseScanPhoto: "Choose scan photo",
    fastCheckIn: "Fast Check-In", fastCheckInHint: "Find or create the customer and vehicle, capture the complaint, and open the workspace.",
    scanStarted: "VIN scan · target under 60 sec", target90Seconds: "Target under 90 sec",
    activeRepairEventExists: "This vehicle already has an active Repair Event",
    continueActiveRepairHint: "Continue the existing workflow instead of creating a duplicate repair event.",
    createRepairEvent: "Create Repair Event",
    fastRoSearchPlaceholder: "Search customer name, phone, VIN, or license plate",
    quickCreateBelow: "Enter the minimum customer and vehicle information below.",
    selected: "Selected", change: "Change", firstName: "First name", lastName: "Last name",
    existingVehicles: "Existing vehicles", selectVehicle: "Select a vehicle",
    serviceRequest: "Service request", complaintPlaceholder: "What brought the vehicle in today?",
    createCheckInOpenWorkspace: "Create RO → Check In → Open Repair Workspace",
    createRepairOrder: "Create repair order", findings: "findings", notStarted: "Not started",
    decodingVin: "Decoding VIN…", vinDecoded: "Vehicle year, make, and model filled from VIN.",
    vinDecodePartial: "VIN was recognized, but complete vehicle details were unavailable.",
    vinDecodeUnavailable: "VIN decoding is temporarily unavailable. You can enter vehicle details manually.",
    draftAutosave: "Draft autosaves every 30 seconds",
    draftSavedAt: "Draft saved at", draftRestored: "Your unfinished repair order draft has been restored.",
    saveDraft: "Save draft", manualSaveHint: "Drafts are saved only when you click Save draft.",
    pageSaved: "Current repair page saved.",
    notInvoiced: "Not invoiced", partMatched: "Part matched", partNotOnRepairOrder: "Part is not on this repair order"
  },
  zh: {
    appSubtitle: "专业汽车维修门店平台",
    signIn: "登录", signInHint: "使用组织账号继续。",
    email: "邮箱", alternatePhone: "备用电话", password: "密码", invalidLogin: "登录失败，请检查账号或密码。",
    foundation: "Dashboard", foundationHint: "生产基础设施状态与访问控制。",
    users: "用户", userManagement: "用户管理", usersAndPermissions: "用户与权限",
    roleManagement: "角色管理", activity: "操作日志", signOut: "退出登录",
    currentAccount: "当前账号", changePassword: "修改密码", personalSettings: "个人设置",
    displayName: "显示名称", currentPassword: "当前密码", newPassword: "新密码",
    confirmNewPassword: "确认新密码", passwordsDoNotMatch: "两次输入的密码不一致。",
    passwordChanged: "密码已修改，请使用新密码重新登录。",
    passwordChangeHint: "修改密码后，所有现有 Refresh Token 会立即失效。",
    roleManagementHint: "创建组织角色、分配权限，并在保留历史关联的情况下停用角色。",
    newRole: "新增角色", editRole: "编辑角色", roleName: "角色名称", roleDescription: "说明",
    permissions: "权限", systemRole: "系统角色", customRole: "自定义角色", enabled: "启用", disabled: "已停用",
    disableRole: "停用角色", enableRole: "启用角色", disableRoleConfirm: "已分配用户将立即失去该角色提供的权限。",
    roleUsers: "已分配用户", adminRoleProtected: "系统管理员角色不可停用、改名或减少权限。",
    roleSaved: "角色已保存。", accessDenied: "你没有权限访问此页面。",
    userManagementHint: "添加人员、分配岗位角色并管理账号访问状态。",
    addPerson: "添加人员", editProfile: "编辑资料", changeRole: "更改角色", resetPassword: "重置密码",
    temporaryPassword: "临时密码", temporaryPasswordHint: "人员首次登录时必须更换此临时密码。",
    passwordChangeRequired: "必须修改密码", firstLoginPasswordHint: "访问 AutoFlow Pro 前，请先更换临时密码。",
    staffRoleAdmin: "管理员", staffRoleManager: "经理", staffRoleFrontDesk: "前台", staffRoleTechnician: "技师",
    disablePerson: "停用人员", enablePerson: "启用人员", disablePersonConfirm: "该人员将立即失去账号访问权限。",
    enablePersonConfirm: "该人员将可以重新登录。", selfAdminRoleProtected: "不能移除自己的管理员角色。",
    resetPasswordHint: "所有现有 Refresh Token 将失效，该人员下次登录时必须修改临时密码。",
    personAdded: "人员已添加。", personUpdated: "资料已更新。", roleAssignmentUpdated: "角色已更新。",
    temporaryPasswordReset: "临时密码已重置。", personStatusUpdated: "账号状态已更新。",
    language: "语言", theme: "主题", light: "浅色", dark: "深色",
    status: "状态", service: "服务", ready: "正常", phase: "当前阶段",
    phaseOne: "第一阶段 · 基础设施", scope: "已批准范围",
    scopeText: "身份认证、RBAC、数据库、Docker、国际化、主题和结构化日志。",
    noBusiness: "第一阶段有意不启用业务模块。",
    phaseTwo: "Sprint 2 · 业务基础",
    sprintTwoScope: "客户、车辆和维修工单基础，包含受控流程与审计历史。",
    noInventory: "库存、采购、支付和报表尚未开发。",
    phaseThree: "Sprint 3 · 维修工作台",
    sprintThreeScope: "围绕完成每一次维修构建持续存在的工作环境。",
    workspaceOnly: "各工作流程区域的业务实现等待后续架构批准。",
    phaseFour: "Sprint 4 · 完整维修流程",
    sprintFourScope: "从车辆检查、报价审批到发票付款，完整完成一张真实维修工单。",
    workflowLive: "检查、报价批准、工时、零件领用、发票和付款均已可操作。",
    name: "姓名", roles: "角色", active: "启用", created: "创建时间",
    action: "操作", entity: "对象", actor: "操作人", time: "时间",
    customers: "客户", customer: "客户", customerListHint: "查找个人或企业客户、车辆和维修历史。",
    newCustomer: "新建客户", editCustomer: "编辑客户", customerProfile: "客户档案",
    vehicles: "车辆", vehicle: "车辆", vehicleListHint: "按 VIN 管理客户名下车辆。",
    newVehicle: "新建车辆", editVehicle: "编辑车辆", vehicleProfile: "车辆档案",
    detailedConfiguration: "详细配置", vehicleConfiguration: "车辆详细配置",
    backToVehicle: "返回车辆档案", nhtsaVehicleConfiguration: "NHTSA 车辆规格",
    noDecodedSpecifications: "暂无可解析的车辆配置。",
    modelYear: "车型年份", trim: "配置版本", series: "车系", bodyClass: "车身类型",
    vehicleType: "车辆类型", manufacturer: "制造商", driveType: "驱动形式",
    doors: "车门数", gvwr: "车辆总重量等级", brakeSystem: "制动系统",
    tractionControl: "牵引力控制", manufacturingPlant: "生产工厂",
    repairOrders: "维修工单", repairWorkspace: "维修工作台",
    workshopOperations: "车间运营", technicianQueue: "技师工作队列",
    technicianQueueHint: "按下一步动作排列实时 Service，让每台车持续向交付推进。",
    myQueue: "我的队列", shopQueue: "全店队列", activeServices: "施工中 Service",
    waitingAttention: "等待 / 需处理", qcQueue: "质检队列", liveUpdated: "实时更新",
    noServicesInQueue: "当前队列没有需要处理的 Service。", openRepairEvent: "打开维修事件",
    actualWorkTime: "实际施工时间", pause: "暂停", resume: "继续", qc: "质检",
    qcPass: "质检合格", qcFail: "不合格 / 返工",
    workSessionRUNNING: "施工中", workSessionPAUSED: "已暂停", workSessionCOMPLETED: "已完工",
    queueActionWAIT_CUSTOMER_APPROVAL: "等待客户确认",
    queueActionISSUE_PARTS: "领用材料", queueActionSTART_SERVICE: "开始 Service",
    queueActionCONTINUE_SERVICE: "正在施工", queueActionRESUME_SERVICE: "继续 Service",
    queueActionSEND_TO_QC: "送交质检", queueActionPERFORM_QC: "执行质检",
    queueActionQC_COMPLETE: "质检完成",
    priorityLOW: "低", priorityNORMAL: "普通", priorityHIGH: "高", priorityURGENT: "紧急",
    repairOrderListHint: "查看门店当前及历史维修工单。",
    newRepairOrder: "新建维修工单", search: "搜索", save: "保存", cancel: "取消",
    edit: "编辑", delete: "删除", phone: "电话", company: "企业", individual: "个人",
    salutation: "称谓", mr: "先生", ms: "女士",
    tags: "标签", notes: "备注", attachments: "附件", history: "历史",
    owner: "车主", vin: "VIN", plate: "车牌", year: "年份", make: "品牌", model: "车型",
    mileage: "里程", color: "颜色", engine: "发动机", transmission: "变速箱", fuelType: "燃料类型",
    lastVisitAt: "上次进厂时间",
    overview: "概览", inspection: "预检", estimate: "报价", preInspectionEstimate: "预检与报价", labor: "工时", parts: "零件",
    photos: "照片", timeline: "时间线", invoice: "发票", payment: "收款", repairHistory: "维修历史", activityLog: "操作日志",
    openWorkspace: "打开工作台",
    customerConcern: "客户诉求", internalNotes: "内部备注", promisedAt: "预计交车时间",
    changeStatus: "更改状态", noData: "暂无记录",
    repairStatus: "维修状态", priority: "优先级", normalPriority: "普通",
    advisor: "服务顾问", technician: "技师", unassigned: "未分配",
    workspaceNavigation: "维修流程导航", workspaceActions: "维修流程操作",
    repairWorkflow: "维修流程", vehicleSummary: "车辆摘要", customerSummary: "客户摘要",
    currentStatus: "当前状态", warranty: "质保", openBalance: "未结余额",
    notConfigured: "未配置", approve: "与客户确认", issueParts: "领用零件",
    print: "打印", closeRepairOrder: "关闭维修工单", repairInformation: "维修信息",
    location: "门店", openedAt: "开单时间", recentActivity: "最近动态",
    lowPriority: "低", highPriority: "高", urgentPriority: "紧急",
    yes: "是", no: "否", workflowProgress: "维修进度", checkedIn: "已接车",
    closed: "已关闭", nextWorkflowAction: "下一步维修动作", repairCompleted: "维修工单已完成",
    addInspectionFinding: "添加预检结果", inspectionItem: "预检项目",
    pass: "正常", attention: "不正常", fail: "不正常", normal: "正常", abnormal: "不正常", add: "添加",
    repairRecommendation: "维修建议",
    completeInspection: "完成预检", addEstimateItem: "添加报价项目",
    fee: "费用", sequence: "序号", type: "类型", description: "说明", unitPrice: "单价", amount: "金额",
    laborCost: "人工", materialCost: "材料", grandTotal: "合计",
    generateEstimatePdf: "打印报价单 PDF", printEstimatePdf: "打印报价单 PDF",
    total: "合计", subtotal: "小计", tax: "税费", discount: "折扣", quantity: "数量", hours: "工时",
    selectPart: "选择零件", submitForApproval: "提交审批",
    shopWork: "车间施工", repairProjects: "维修项目", vehicleRepairProjects: "车辆维修项目", repairItem: "维修项目",
    requiredMaterials: "材料", materials: "材料", materialName: "材料名称",
    addItem: "可增项", selectTechnician: "选择技师",
    customerSuppliedParts: "自带配件", noCustomerSuppliedParts: "暂无自带配件。",
    completeAndSendToInspector: "完工并推送检验员",
    settlement: "结算", settlementBreakdown: "费用清单", otherCharges: "其它费用",
    financialAdjustmentsBeforeCollection: "首次收款前，可以最终确认其它费用和折扣。",
    financialAdjustmentsLocked: "开始收款后，其它费用和折扣将锁定，不能继续修改。",
    completeAndSettle: "完工并结算",
    addLabor: "添加工时", addMaterial: "添加材料", addCustomerSuppliedPart: "添加自带配件",
    inventoryMaterial: "库存材料", freeMaterial: "自由添加材料",
    sku: "SKU", materialSupplier: "供应商",
    workshopNotesAndDisclaimer: "备注及免责声明", workshopNotes: "备注",
    workshopNotesPlaceholder: "填写车间施工备注",
    disclaimer: "免责声明",
    customerSuppliedPartDisclaimer: "客户自带配件可能不适用本店的配件质保；工时质保及客户依法享有的权利，以适用法律和本店书面政策为准。",
    collectPayment: "收款", paymentAvailableAfterInspection: "检验员验收合格并开具发票后，方可收款。",
    passInspectionIssueInvoice: "检验合格，发票开具",
    paymentMethodCASH: "现金", paymentMethodTRANSFER: "转账", paymentMethodCHECK: "支票",
    paymentMethodPAYPAL: "PayPal", paymentMethodZELLE: "Zelle",
    printEstimate: "打印估价单", printWorkshopOrder: "打印车间维修施工单",
    printSettlement: "打印结算单", workshopRepairOrder: "车间维修施工单",
    settlementStatement: "结算单",
    uploadAttachment: "上传附件", confirmationAttachments: "客户确认附件",
    customerApprovalName: "客户姓名", approveEstimate: "与客户确认",
    customerConfirmationName: "客户姓名", confirmWithCustomer: "与客户确认",
    confirmationText: "文字", confirmationImage: "图片",
    confirmationRecording: "电话录音", confirmationSignedEstimate: "客户签字的报价单",
    confirmationEvidence: "确认内容或文件编号",
    customerConfirmedBy: "客户确认",
    supplementRequired: "需要增项确认 / 等待客户重新批准",
    supplementRequiredHint: "施工中增加了人工或材料。客户确认增项前，不能继续施工、完工、检验、开票或结算。",
    supplementChangedScope: "本次需确认的变更", supplementEstimateChanges: "人工 / 材料价格或数量发生变更",
    supplementTotal: "更新后总计",
    approveSupplement: "确认增项",
    serviceIntelligence: "维修知识服务",
    workflowFirst: "维修流程优先",
    serviceIntelligenceHint: "优先添加与当前车辆匹配的 Service；系统将从知识库带出标准工时、推荐配件和检查规则。",
    searchMatchedService: "搜索适用于当前车辆的维修服务",
    addService: "添加 Service",
    serviceChangeStatusHint: "仅可在报价准备或车辆施工阶段变更 Service。",
    noServices: "当前工单尚未添加结构化维修服务。",
    repairOperatingSystem: "维修运营系统", repairEventExperience: "维修事件工作台",
    roleWorkflowFocus: "角色工作重点", advisorWorkflowFocus: "客户沟通 · 报价 · 确认 · 收款",
    technicianWorkflowFocus: "预检 · Service · 证据 · 工时 · 质检",
    partsWorkflowFocus: "所需材料 · 准备 · 领用", ownerWorkflowFocus: "车辆流转 · 瓶颈 · 交付",
    whatHappensNextForVehicle: "每个动作都让这台车更接近交付。",
    visitReason: "到店原因", visitReasonHint: "客户原话与服务顾问说明分别保留。",
    customerWords: "客户原话", awaitingAdvisorClarification: "等待服务顾问补充说明",
    whatWeFound: "发现的问题", whatWeFoundHint: "预检结果和证据说明车辆为什么需要维修。",
    whatWeRecommend: "维修建议", serviceCardsAreWorkUnits: "Service 将发现、确认、材料、工时、施工、质检和价格连成一体。",
    customerDecision: "客户决定", customerDecisionHint: "已确认范围和每次增项都持续可见。",
    shopExecution: "车间执行", shopExecutionHint: "技师在同一个维修事件内完成已授权 Service。",
    commercialClose: "结算交付", commercialCloseHint: "质检、发票、收款和放车共同完成本次维修。",
    timelineV2: "时间线 V2", timelineImmutableHint: "所有关键动作自动生成且不可修改的维修叙事。",
    timelineFilterALL: "全部", timelineFilterCUSTOMER: "客户确认",
    timelineFilterWORK: "施工", timelineFilterPARTS: "材料",
    timelineFilterQC: "质检", timelineFilterCOMMERCIAL: "发票 / 收款",
    repairHistoryHint: "由已完成维修事件自动形成的车辆长期记录。",
    businessOperations: "经营收尾",
    invoiceIssued: "已开发票", paymentComplete: "已完成收款",
    vehicleDelivered: "车辆已交付", historyCompleted: "历史已归档",
    customerCommunication: "客户沟通",
    communicationChannelSMS: "短信", communicationChannelEMAIL: "电子邮件",
    communicationChannelPHONE: "电话", communicationChannelIN_PERSON: "当面",
    communicationPurposeESTIMATE: "报价", communicationPurposeAPPROVAL: "客户确认",
    communicationPurposeREADY_FOR_PICKUP: "通知取车",
    communicationPurposeINVOICE: "发票", communicationPurposePAYMENT_RECEIPT: "付款收据",
    communicationPurposeDELIVERY: "车辆交付", communicationPurposeFOLLOW_UP: "维修回访",
    communicationPurposeWARRANTY: "质保",
    recipient: "接收人 / 联系方式", communicationMessage: "沟通内容",
    recordCommunication: "记录沟通", noCustomerCommunications: "暂无客户沟通记录。",
    vehicleDelivery: "车辆交付", deliverVehicle: "交付车辆",
    deliverVehicleAndCompleteHistory: "交付车辆并完成维修历史",
    deliveryRecipient: "车辆领取人", mileageOut: "出厂里程", deliveryNotes: "交车备注",
    deliveryRequiresPayment: "发票全部结清后，才能放行车辆。",
    releasedAt: "交车时间", releasedBy: "放车人员",
    warrantyCoverage: "质保关联", laborWarrantyEnds: "工时质保截止",
    partsWarrantyEnds: "配件质保截止", noWarrantyCoverage: "本次 Service 无适用质保。",
    permanentRepairHistory: "永久维修历史",
    historyCreatedAtDelivery: "车辆交付时，系统将自动生成不可变的永久维修历史。",
    system: "系统",
    forensicAuditHint: "系统审计记录与日常维修叙事分开保留。",
    serviceOriginFINDING: "预检发现", serviceOriginCUSTOMER_REQUEST: "客户要求",
    serviceOriginMAINTENANCE: "保养规则", serviceOriginREPAIR_RULE: "维修规则", serviceOriginMANUAL: "手动添加",
    serviceUrgencyIMMEDIATE: "立即处理", serviceUrgencySOON: "尽快处理", serviceUrgencyROUTINE: "常规",
    serviceStatusPROPOSED: "待确认", serviceStatusAPPROVED: "已确认", serviceStatusDECLINED: "已拒绝",
    serviceStatusIN_PROGRESS: "施工中", serviceStatusCOMPLETED: "已完成",
    serviceQcNOT_REQUIRED: "无需质检", serviceQcPENDING: "等待质检", serviceQcPASSED: "质检合格", serviceQcFAILED: "质检不合格",
    whyThisService: "为什么需要此 Service", customerRequest: "客户要求", recommendation: "维修建议",
    knowledgeRuleApplied: "已应用维修知识规则", startServiceWork: "开始 Service",
    completeServiceWork: "完成 Service", addEvidence: "添加证据",
    evidencePHOTO: "照片", evidenceVIDEO: "视频", evidenceMEASUREMENT: "测量数据", evidenceOBD: "OBD 数据",
    evidenceDOCUMENT: "文件", evidenceAUDIO: "录音", evidenceSIGNATURE: "签字",
    evidenceOEM_REFERENCE: "OEM 参考", evidenceSummary: "该证据说明什么？",
    measurementOrCode: "测量值或诊断码", unit: "单位", chooseEvidenceFile: "选择证据文件",
    customerVisible: "客户可见", internalOnly: "仅内部可见", saveEvidence: "保存证据",
    evidence: "证据", noServiceEvidence: "该 Service 尚未添加证据。",
    workStatus: "施工状态", partsReadiness: "材料准备", months: "个月",
    serviceTotal: "Service 合计", serviceTimeline: "Service 时间线", noServiceTimeline: "暂无 Service 动态。",
    serviceApproved: "已确认",
    serviceProposed: "待确认",
    oemLaborTime: "OEM 标准工时",
    shopLaborTime: "门店标准工时",
    finalLaborTime: "最终工时",
    laborRate: "工时单价",
    laborAmount: "人工金额",
    laborOverride: "工时调整",
    overrideLabor: "调整工时",
    overrideReasonRequired: "调整原因（必填）",
    addPartToService: "为 Service 添加材料",
    partNumber: "配件号",
    recommendedParts: "Service 材料",
    noRecommendedParts: "暂无推荐材料。",
    inspectionRecommendations: "检查与维修建议",
    noRecommendations: "暂无关联规则。",
    source: "来源",
    issueStatus: "领用状态",
    notIssued: "未领用",
    ruleRECOMMEND_SERVICE: "推荐服务",
    ruleRECOMMEND_PART: "推荐配件",
    ruleINSPECTION: "检查项目",
    ruleMESSAGE: "施工提示",
    manualLaborPartFallback: "下方仍保留手动添加工时和材料，作为特殊情况的备用入口。",
    taxableMaterials: "应税配件/材料",
    losAngelesSalesTax: "洛杉矶销售税（9.75%）",
    approvedBy: "确认人", startRepairWork: "开始维修", authorizedLabor: "已授权工时",
    start: "开始", complete: "完成", awaitingApprovedEstimate: "等待报价批准。",
    requiredParts: "所需零件", required: "需要", issued: "已领用", onHand: "现有库存", issue: "领用",
    repairPhotos: "维修照片", upload: "上传", invoiceCreatedAtReadyDelivery: "质检通过后自动开具发票。",
    invoiceRequiredBeforePayment: "完成质检并开具发票后才能收款。",
    recordPayment: "记录收款", reference: "参考号", paymentHistory: "收款记录", paid: "已收款",
    roNumberAutomatic: "保存时将自动生成维修工单号。",
    checkInVehicle: "车辆接车", checkInDescription: "确认车辆已经到店，并开始完整维修流程。",
    startWorkDescription: "客户已批准报价，可以开始授权维修项目。",
    beginQualityCheck: "提交车间检验员验收", qualityDescription: "所有已确认维修项目完成后，将车辆交车间检验员验收。",
    passQcIssueInvoice: "验收合格并通知客户", readyDescription: "记录检验员验收结果、开具发票并通知客户取车。",
    closeDescription: "款项已经结清，可以关闭维修工单。",
    qaTools: "质量保证", inputStandardsTest: "输入规范测试",
    inputStandardsHint: "用于集中验证键盘输入和显示格式的受控测试页面。",
    qaOnly: "仅限测试", keyboardTestHint: "使用 Tab 键切换输入框，使用 Enter 键提交测试表单。",
    vinStandard: "VIN 标准化", vinStandardHelp: "固定 17 位，自动大写，不允许 I、O、Q。",
    phoneStandard: "美国电话格式", phoneStandardHelp: "连续输入数字，程序自动添加括号和连字符。",
    dateStandard: "日期时间格式", dateAndTime: "日期与时间",
    currencyStandard: "美元格式", currencyAmount: "金额",
    mileageStandard: "里程格式", roNumberStandard: "维修工单号",
    actualValue: "实际值", generatedFormat: "生成格式", generationOwner: "生成位置",
    testKeyboardSubmit: "测试 Enter 提交", resetTestValues: "恢复测试值",
    keyboardSubmitPassed: "键盘提交测试通过",
    frontDesk: "前台接车", todaysRepairs: "今日维修", inventory: "库存", inventoryManagement: "库存", inventoryOverview: "库存总览",
    purchase: "采购", reports: "报表", administration: "设置",
    today: "今天", vehiclesToday: "台今日车辆", todaysVehicles: "今日车辆",
    frontDeskHint: "快速找到下一步维修动作，完成接车，并推动今日车辆持续流转。",
    frontDeskV2Hint: "找到车辆、记录到店原因，并直接进入这台车的下一步维修动作。",
    universalCommandBar: "通用指令栏", commandBarPlaceholder: "VIN、车牌、客户、工单或指令",
    commandBarHint: "无需离开维修事件即可搜索或执行动作", printInvoice: "打印发票",
    target60Seconds: "目标 60 秒内", searchValueWillBeReused: "检索内容会自动带入接车表单。",
    startNewRepairEvent: "开始新维修事件", newRepairEvent: "新建维修事件",
    activeVehicles: "在店车辆", overdueAttention: "逾期待处理", promiseRisk: "交车风险",
    nextActionBoardHint: "每一列都明确这台车下一步由谁处理。",
    noVehiclesWaiting: "暂无待处理车辆", activeRepairEvents: "进行中的维修事件",
    continueActiveRepair: "继续当前维修", selectVehicleNext: "下一步选择车辆",
    nextAction: "下一步动作", minutesWaiting: "分钟等待", waiting: "等待中",
    attentionWaitingInspection: "等待预检", attentionWaitingEstimate: "等待报价",
    attentionWaitingApproval: "等待客户", attentionWaitingParts: "等待材料",
    attentionWorkshop: "车间施工", attentionWaitingQc: "等待质检", attentionPaymentPickup: "收款 / 取车",
    attentionDRAFT: "草稿", attentionWAITING_INSPECTION: "等待预检",
    attentionWAITING_ESTIMATE: "等待报价", attentionWAITING_CUSTOMER_APPROVAL: "等待客户确认",
    attentionWAITING_PARTS: "等待材料", attentionWAITING_TECHNICIAN: "等待分配技师",
    attentionWORK_IN_PROGRESS: "施工中", attentionWAITING_QC: "等待质检",
    attentionWAITING_PAYMENT: "等待收款", attentionREADY_PICKUP: "等待取车",
    attentionREADY_TO_CLOSE: "等待交车",
    completeCheckIn: "完成接车", startInspection: "开始预检", buildEstimate: "制作报价",
    followUpApproval: "跟进客户确认", resolveParts: "处理材料", dispatchService: "分配技师",
    continueRepair: "继续施工", performQc: "执行质量检验",
    closeRepairEvent: "关闭维修事件", viewRepairHistory: "查看维修历史",
    roleFRONT_DESK: "前台", roleTECHNICIAN: "技师", roleADVISOR: "服务顾问",
    roleWAREHOUSE: "仓库", roleDISPATCHER: "调度", roleQC: "检验员", roleNONE: "未分配",
    globalSearchPlaceholder: "搜索 VIN、车牌、电话、客户或工单号",
    boardCheckedIn: "已接车", boardWaitingApproval: "等待批准", boardApproved: "已批准",
    boardInProgress: "维修中", boardWaitingParts: "等待零件", boardReadyPickup: "等待取车",
    boardUpdatesAutomatically: "实时维修流程 · 每 30 秒自动刷新",
    noPlate: "无车牌", noSearchResults: "未找到匹配的客户、车辆或维修工单。",
    noVehicles: "暂无车辆", noPromiseTime: "未设置交车时间", searching: "正在搜索…",
    scan: "扫描", scanHint: "扫描 VIN、维修工单二维码或零件条码。",
    stopCamera: "停止摄像头", useCamera: "使用摄像头", orUseScanner: "或使用 USB / 蓝牙扫描枪",
    scanVin: "扫描 VIN", scanPlate: "扫描车牌", chooseFromPhotos: "从相册选择",
    fieldScanHint: "使用摄像头，或选择相册内已有的条码/二维码照片。",
    invalidVinScan: "未识别到有效的 17 位 VIN。",
    invalidPlateScan: "未识别到有效车牌信息。",
    photoScanFailed: "照片中未找到可读取的条码或二维码。",
    scanInputPlaceholder: "扫描或输入编码，然后按 Enter", go: "执行",
    repairOrderNotFound: "未找到维修工单。", partScanWorkspaceOnly: "零件扫描只能在维修工作台内使用。",
    scanNotRecognized: "无法识别扫描内容。", cameraUnavailable: "摄像头不可用或未获得权限。",
    scanPhotoUnreadable: "照片中未识别到 VIN、维修工单二维码或条码。",
    chooseScanPhoto: "选择扫描照片",
    fastCheckIn: "快速接车", fastCheckInHint: "查找或新建客户与车辆，记录诉求，然后直接进入维修工作台。",
    scanStarted: "VIN 扫描接车 · 目标 60 秒内", target90Seconds: "目标 90 秒内",
    activeRepairEventExists: "该车辆已有进行中的维修事件",
    continueActiveRepairHint: "请继续当前维修流程，不要为同一车辆创建重复维修事件。",
    createRepairEvent: "创建维修事件",
    fastRoSearchPlaceholder: "搜索客户姓名、电话、VIN 或车牌",
    quickCreateBelow: "请在下方填写最少的客户和车辆资料。",
    selected: "已选择", change: "更换", firstName: "名字", lastName: "姓氏",
    existingVehicles: "已有车辆", selectVehicle: "选择车辆",
    serviceRequest: "维修诉求", complaintPlaceholder: "车辆今天因为什么问题到店？",
    createCheckInOpenWorkspace: "创建工单 → 接车 → 打开维修工作台",
    createRepairOrder: "创建维修工单", findings: "项结果", notStarted: "尚未开始",
    decodingVin: "正在解析 VIN…", vinDecoded: "已根据 VIN 自动填写车辆年份、品牌和车型。",
    vinDecodePartial: "已识别 VIN，但无法获得完整车辆资料。",
    vinDecodeUnavailable: "VIN 解析暂时不可用，您仍可手动填写车辆资料。",
    draftAutosave: "草稿每 30 秒自动保存",
    draftSavedAt: "草稿已保存于", draftRestored: "已恢复上次未完成的维修工单草稿。",
    saveDraft: "保存草稿", manualSaveHint: "仅在点击“保存草稿”时保存，不再自动保存。",
    pageSaved: "当前维修页面已保存。",
    notInvoiced: "尚未开票", partMatched: "零件匹配成功", partNotOnRepairOrder: "该零件不在当前维修工单中"
  }
} as const;

export type Locale = keyof typeof messages;
